import React from 'react';
import { useIntl } from 'react-intl';
import { Option, Select } from 'carbon-react/lib/components/select';

import { EndDateType } from '../../../types';
import styles from '../repeating-method.scss';

interface EndTypeProps {
  disabled?: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  value: string;
}

export const EndType = ({ disabled, onChange, value }: EndTypeProps) => {
  const intl = useIntl();

  return (
    <div className={styles.carbonActionItem}>
      <Select
        autoComplete="off"
        disabled={disabled}
        onChange={onChange}
        value={value}
        label={intl.formatMessage({ id: 'common.end', defaultMessage: 'End' })}
        size="large"
      >
        <Option
          text={intl.formatMessage({ id: 'common.never', defaultMessage: 'Never' })}
          value={EndDateType.end_never}
        />
        <Option
          text={intl.formatMessage({ id: 'common.After_n_occurrences', defaultMessage: 'After' })}
          value={EndDateType.end_after}
        />
        <Option
          text={intl.formatMessage({ id: 'common.end_on', defaultMessage: 'End on' })}
          value={EndDateType.end_on_date}
        />
      </Select>
    </div>
  );
};
